import {createSlice} from "@reduxjs/toolkit";
import {getCalendar} from "./action";

const initialState = {
	state: [],
	loading: true,
	error: ''
} as BaseState<CalendarState[]>

const slice = createSlice({
	name: 'calendarSlice',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getCalendar.pending, (state) => ({
				...state,
				loading: true
			})
		)
		builder.addCase(getCalendar.fulfilled, (state, action) => (
				{
					state: [...action.payload],
					loading: false,
					error: null
				}
			)
		)
		builder.addCase(getCalendar.rejected, () => ({
				state: [],
				loading: false,
				error: 'Failed to get calendars, please try again'
			})
		)
	}
})

export default slice
